import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { customHistory } from 'utils/customBrowserRouter';
import { isAuthenticated } from 'helpers/isAuthenticated';
import { getRefreshTokenAction } from 're-ducks/auth';
import { store } from 'index';

const PrivateRoute = ({ children }) => {
  const getToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');

  if (isAuthenticated() === false) {
    store.dispatch(
      getRefreshTokenAction(
        { refreshToken },
        () => {
          window.location.reload();
        },
        (error) => {
          if (error.response?.status === 401) {
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('persist:root');
            <Navigate to="/auth/sign-in" />;
            window.location.reload();
          }
        }
      )
    );
  } else if (getToken === null || undefined) {
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('acessToken');
    localStorage.removeItem('persist:root');
    return customHistory.push('/auth/sign-in');
  } else {
    return <>{children}</>;
  }
};

PrivateRoute.propTypes = {
  children: PropTypes.oneOf([PropTypes.ReactNode, PropTypes.func])
};

export default PrivateRoute;
